import styled from 'styled-components'
import { Breakpoints } from '@/shared/styles/breakpoints'
import * as zero from '@zero/design-tokens/build/js/variables'


export const Container = styled.div`
    align-self: center;
    margin: ${zero.ZrSpacingVerticalMicro} 0 ${zero.ZrSpacingVerticalMicro} 0;
    transform: rotate(90deg);    
    flex: unset;            
    text-align: unset;
    img{
        display: inline;
    }

    @media screen and (min-width: ${Breakpoints.menu}){                
        transform: rotate(0deg);
        margin: 0;
        flex:1;        
        align-self: center;
        text-align: center;
        min-width: 70px;        
    }
`